module.exports = __webpack_public_path__ + "static/img/5.857c695.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/zh/5.png
// module id = N2O1
// module chunks = 0